<template>
    <td-dialog :visible.sync="designDataSourceDialogVisible" :title="$t('pgCommon.DESIGN_DATA_SOURCE')" :before-close="cancel" :close-on-click-modal="false" width="1150px">
        <el-row>
            <el-col style="margin-bottom: 20px;">
                <td-button type="primary" @click="addTab"> {{ $t('pgCommon.ADD_NORMAL_FIELDS') }}</td-button>
                <td-button type="primary" @click="addTabs"> {{ $t('pgCommon.ADD_CORE_FIELDS') }}</td-button>
                <span style="color:red;margin-left: 20px;">{{ $t('pgNavbar.CANT_USE_SQL_KEY') }}</span>
            </el-col>
        </el-row>
        <div v-for="(item, index) in addDesignDataSourceList" :key="index" style="margin-bottom: 20px;">
            <span>{{ item.fieldName }}</span>
            <td-input :disabled="item.hidden" v-model="item.english" :maxlength="100" style="margin-left: 10px;" type="text" :clearable="false"></td-input>
            <span style="margin-left: 20px;">{{ $t('pgCommon.DESCRIPTION') }}</span>
            <td-input :disabled="item.hiddens" v-model="item.val" :maxlength="100" style="margin-left: 10px;"> </td-input>
            <span style="margin-left: 20px;">{{ $t('pgCommon.FIELDS_LENGTH') }}</span>
            <td-select
                :disabled="item.fieldsLengthHidden"
                keys="id"
                style="margin-left: 20px;"
                v-model="item.fieldsLength"
                :options="options"
                width="90"
                :clearable="false"
                value="100"
                @change="change(index)"
            ></td-select>
            <span style="margin-left: 20px;">{{ $t('pgCommon.REMARKS') }}</span>
            <td-input :disabled="item.hiddens" v-model="item.remarks" :maxlength="100" style="margin-left: 10px;"></td-input>
            <td-button v-if="!item.hidden" style="margin-left: 20px; " type="primary" @click="removeTab(index)"> {{ $t('pgCommon.DELETE') }}</td-button>
        </div>
        <span slot="footer">
            <td-button type="primary" @click="save">{{ $t('pgCommon.SAVE') }}</td-button>
            <td-button @click="cancel">{{ $t('pgCommon.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import api from '../assets/api.js';
export default {
    props: {
        designDataSourceDialogVisible: {
            type: Boolean
        },
        templateKey: {
            type: String
        }
    },
    components: {},
    created() {
        this.deleteNameList = [];
        this.queryDesignDataSource();
    },
    data() {
        return {
            options: [
                {
                    id: '100'
                },
                {
                    id: '200'
                },
                {
                    id: '400'
                },
                {
                    id: '800'
                },
                {
                    id: '1600'
                },
                {
                    id: '3200'
                },
                {
                    id: '4000'
                },
                {
                    id: 'longtext'
                }
            ],
            targetName: '',
            ele: '',
            deleteNameList: [],
            addDesignDataSourceList: []
        };
    },
    methods: {
        change(index) {
            this.addDesignDataSourceList[index].fieldsLength;
        },
        queryDesignDataSource() {
            let templateKeys = 'PROCESS_' + this.templateKey;
            let param = {
                deleteNameList: this.deleteNameList,
                templateKey: templateKeys,
                nameList: this.addDesignDataSourceList
            };
            api.queryDesignDataSource(param, response => {
                if (response.data.content == null || response.data.content == '') {
                    return;
                }
                let tempList = response.data.content;
                for (let i = 0; i < tempList.length; i++) {
                    if (tempList[i].hidden == 'true') {
                        tempList[i].hidden = true;
                    } else {
                        tempList[i].hidden = false;
                    }
                    if (tempList[i].hiddens == 'true') {
                        tempList[i].hiddens = true;
                    } else {
                        tempList[i].hiddens = false;
                    }
                    tempList[i].fieldsLengthHidden = true;
                    if (tempList[i].fieldName == this.$t('pgCommon.CORE_FIELDS_NAME')) {
                        tempList[i].english = tempList[i].english.substring(3);
                    }
                    let valAndRemarks = tempList[i].val.split('_');
                    if (!this.$util.isEmpty(valAndRemarks[0])) {
                        tempList[i].val = valAndRemarks[0];
                    }
                    if (!this.$util.isEmpty(valAndRemarks[1]) && valAndRemarks[1] != 'undefined') {
                        tempList[i].remarks = valAndRemarks[1];
                    }
                }
                this.addDesignDataSourceList = tempList;
            });
        },
        save() {
            let tempList = [];
            let tempList1 = [];
            let tempList2 = [];
            for (let i = 0; i < this.addDesignDataSourceList.length; i++) {
                if (this.addDesignDataSourceList[i].tempNum == 1 || this.addDesignDataSourceList[i].tempNum == 0 || this.addDesignDataSourceList[i].english == '') {
                    this.$message({
                        message: this.$t('pgRegex.FIELD_NAME_CANNOT_BE_EMPTY_FIELD_NAME_CAN_ONLY_BE_UPPERCASE_OR_UNDERLINE'),
                        type: 'warning'
                    });
                    return;
                }
                let tempEnglish = this.addDesignDataSourceList[i].english.replace(/\s+/g, '');
                if (
                    tempEnglish == 'S_ID' ||
                    tempEnglish == 'DT_CREATE_TIME' ||
                    tempEnglish == 'DT_UPDATE_TIME' ||
                    tempEnglish == 'S_CREATE_USER' ||
                    tempEnglish == 'S_UPDATE_USER' ||
                    tempEnglish == 'I_DEL_FLG'
                ) {
                    this.$message({
                        message: this.$t('pgRegex.THE_FIELD_NAME_CANNOT_BE_THE_DATABASE_DEFAULT_FIELD'),
                        type: 'warning'
                    });
                    return;
                }
                tempList.push(this.addDesignDataSourceList[i].english);
                tempList1.push(this.addDesignDataSourceList[i].val);
                tempList2.push(this.addDesignDataSourceList[i].val + this.addDesignDataSourceList[i].remarks);
                this.addDesignDataSourceList[i].valAndRemarks = this.addDesignDataSourceList[i].val + '_' + this.addDesignDataSourceList[i].remarks;
            }
            for (let i = 0; i < tempList.length; i++) {
                let e = tempList[i];
                var zmReg = /(^_([A-Z0-9]_?)*$)|(^[A-Z](_?[A-Z0-9])*_?$)/;
                if (!zmReg.test(e)) {
                    this.$message({
                        message: this.$t('pgRegex.FIELD_NAME_CANNOT_BE_EMPTY_FIELD_NAME_CAN_ONLY_BE_UPPERCASE_OR_UNDERLINE'),
                        type: 'warning'
                    });
                    return;
                }
                //校验描述和备注，不允许输入，和_
                let description = tempList2[i];
                const Reg = /^[^,_]+$/;
                if (!Reg.test(description)) {
                    this.$message({
                        message: this.$t('pgRegex.NOT_ALLOW_INPUT_CHAR'),
                        type: 'warning'
                    });
                    return;
                }
            }
            let uniq = this.unique(tempList);
            let uniq1 = this.unique(tempList1);
            if (tempList.length != uniq.length || tempList1.length != uniq1.length) {
                this.$message({
                    showClose: true,
                    message: this.$t('pgRegex.FIELD_NAME_CANNOT_BE_DUPLICATE'),
                    type: 'warning'
                });
                return;
            }
            let templateKeys = 'PROCESS_' + this.templateKey;
            let param = {
                deleteNameList: this.deleteNameList,
                templateKey: templateKeys,
                nameList: this.addDesignDataSourceList
            };
            api.designDataSource(param, response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    return;
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    return;
                }
                this.$message({ showClose: true, message: this.$t('pgCommon.MODIFY_SUCCESS'), type: 'success' });
                this.cancel();
            });
        },
        unique(array) {
            //一个新的数组
            var arrs = [];
            //遍历当前数组
            for (var i = 0; i < array.length; i++) {
                //如果临时数组里没有当前数组的当前值，则把当前值push到新数组里面
                if (arrs.indexOf(array[i]) == -1) {
                    arrs.push(array[i]);
                }
            }
            return arrs;
        },
        removeTab(index) {
            this.$confirm(this.$t('pgCommon.TIPSSS'), this.$t('extendCommon.TIPS'), {
                confirmButtonText: window.vue.$t('extendCommon.CONFIRM'),
                cancelButtonText: window.vue.$t('extendCommon.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    if (this.addDesignDataSourceList[index].english != '') {
                        this.deleteNameList.push(this.addDesignDataSourceList[index].english);
                    }
                    this.addDesignDataSourceList.splice(index, 1);
                })
                .catch(() => {});
        },
        addTabs() {
            let cope = {
                hiddens: false,
                hidden: false,
                fieldName: this.$t('pgCommon.CORE_FIELDS_NAME'),
                english: '',
                val: '',
                fieldsLength: '400'
            };

            this.addDesignDataSourceList.push(cope);
        },
        addTab() {
            let cope = {
                hiddens: false,
                hidden: false,
                fieldName: this.$t('pgCommon.NORMAL_FIELDS_NAME'),
                english: '',
                val: '',
                fieldsLength: '400'
            };
            this.addDesignDataSourceList.push(cope);
        },
        cancel() {
            this.$emit('designDataSourceDialogColse');
        }
    }
};
</script>
<style></style>
